const countySensitiveRegions = [
  'AR',
  'FL',
  'IL',
  'KS',
  'OH'
];

export default countySensitiveRegions;